const INITIAL_STATE = {
    idDialogShow: ''
}

export default function Dialog(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'TOGGLE_SHOW_DIALOG':
            return { ...state, idDialogShow: action.payload }
        default:
            return state
    }
}